import { CIcon } from '~/icons/types'

export const ciThreeDots: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M5.2 12a1.2 1.2 0 1 0-2.4 0 1.2 1.2 0 0 0 2.4 0Zm8 0a1.2 1.2 0 1 0-2.4 0 1.2 1.2 0 0 0 2.4 0Zm8 0a1.2 1.2 0 1 0-2.4 0 1.2 1.2 0 0 0 2.4 0Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'three-dots',
  type: 'thin'
}
